import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IdleService } from "./core/service/idle.service";
import { environment } from "../environments/environment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'gesthispania-tools';
  // @ts-ignore
  @ViewChild('staticBackdropModal') staticBackdropModal: ElementRef | undefined;
  modalRef: any;

  constructor(private idleService: IdleService,
              private modalService: NgbModal,
              private router: Router,
              private location: Location) {
  }

  ngOnInit(): void {
    this.initialIdleSettings();
  }

  private initialIdleSettings() {
    const idleTimeoutInSeconds: number = environment.idleTimeInMinutes * 60;
    this.idleService.startWatching(idleTimeoutInSeconds).subscribe((isTimeOut: boolean) => {
      if (isTimeOut) {
        if(!this.location.path().includes('auth')){
          this.modalRef = this.modalService.open(this.staticBackdropModal, { backdrop: 'static', keyboard: false });
          this.idleService.stopTimer();
        }
      }
    });
  }

  logOut() {
    this.modalService.dismissAll();
    this.router.navigate(['/auth/logout']);
  }

}
